export default "__VITE_ASSET__YWf1D7I$__"